import React from "react";
import { connect } from "react-redux";

function PageTile(props) {
    const { dealjacket, page, toggleCarousel, setCurrentPageIndex, setCurrentJacketPages, jwt, limit_pipeline } = props;



    const file_path = page?.image_path + "/?t=" + jwt;

    return (
        <div className="pageTile">
            <div className="pageImageDiv">
                <img
                    className="pageImage"
                    src={file_path}
                    loading="lazy"
                    alt={page?.page_id || ""}
                    width="204"
                    height="264"
                    onClick={() => {
                        const pageIndex = dealjacket.findIndex(
                            (p) => p.page_id === page.page_id
                        );
                        setCurrentJacketPages(dealjacket);
                        setCurrentPageIndex(pageIndex);
                        toggleCarousel();
                    }}
                />
            </div>
            <div className="pageTileInfo">
                {
                    !limit_pipeline &&
                    <table className="pageTileInfoTable">
                        <tbody>
                            <tr>
                                <td width="40%">
                                    Group:
                                </td>
                                <td>
                                    {page?.page_group_name}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Page Type:
                                </td>
                                <td>
                                    {page?.page_type_name}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                }

            </div>


        </div>
    );

}

function mapStateToProps(state) {
    const { authentication } = state;
    return {
        authentication
    };
}

const connectedPageTile = connect(mapStateToProps)(
    PageTile
);
export { connectedPageTile as PageTile };
